import {
  cilApplicationsSettings,
  cilMenu, cilPencil,
  cilSearch,
  cilSpeedometer, cilTrash,
  cilPlus,
  cilInfo,
  cilWarning,
  cilPlaylistAdd, cilLocationPin,
  cilImage,
  cilSun,
  cilMoon,
  cilBell,
  cilBook,
  cilCheck,
  cilNotes,
  cilSync,
  cilUser,
  cilPeople,
  cilSquare, cilChevronLeft, cilChevronRight,
  cilXCircle,
  cilDollar,
  cilCopy,
  cilCloudDownload,
  cilEnvelopeClosed,
  cilFilter,
  cilActionUndo,
  cilX
} from '@coreui/icons';

import {
  cisInputComponent,
  cisDocument,
  cisHome,
  cilFileAdd,
  cisInfo,
  cisGroup,
  cisSpreadsheet,
  cilQueueAdd,
  cilPaperclip,
  cilCallToAction,
  cisPeople,
  cilSnow,
  cilTruck,
  cilCheckDouble,
  cisUser,
  cisLocationPin,
  cisSync,
  cisCloudDownload,
  cisEnvelopeClosed,
  cisCheck,
  cisX,
  cisWarning
} from "@coreui/icons-pro";

export const iconSubset = {
  cilApplicationsSettings,
  cilMenu,
  cilSpeedometer,
  cisHome,
  cisInputComponent,
  cisDocument,
  cilPencil,
  cilTrash,
  cilFileAdd,
  cilPlus,
  cilInfo,
  cilWarning,
  cisInfo,
  cilPlaylistAdd,
  cisGroup,
  cisSpreadsheet,
  cilQueueAdd,
  cilPaperclip,
  cilLocationPin,
  cilCallToAction,
  cilImage,
  cilSun,
  cilMoon,
  cisPeople,
  cilBell,
  cilBook,
  cilCheck,
  cilCheckDouble,
  cilNotes,
  cilSync,
  cilUser,
  cilPeople,
  cilSquare,
  cilSnow,
  cilTruck,
  cilChevronLeft,
  cilChevronRight,
  cilXCircle,
  cilDollar,
  cilCopy,
  cilCloudDownload,
  cilEnvelopeClosed,
  cisUser,
  cisLocationPin,
  cisSync,
  cisCloudDownload,
  cisEnvelopeClosed,
  cilFilter,
  cilActionUndo,
  cilX,
  cisCheck,
  cisX,
  cisWarning,
  cilSearch
};

export enum IconSubset {
  cilApplicationsSettings = 'cilApplicationsSettings',
  cilMenu = 'cilMenu',
  cilSpeedometer = 'cilSpeedometer',
  cisDocument = 'cisDocument',
  cisHome = 'cisHome',
  cisInputComponent = 'cisInputComponent',
  cilPencil = 'cilPencil',
  cilTrash = 'cilTrash',
  cilFileAdd = 'cilFileAdd',
  cilPlus = 'cilPlus',
  cilInfo = 'cilInfo',
  cilWarning = 'cilWarning',
  cisInfo = 'cisInfo',
  cilPlaylistAdd = 'cilPlaylistAdd',
  cisGroup = 'cisGroup',
  cisSpreadsheet = 'cisSpreadsheet',
  cilQueueAdd = 'cilQueueAdd',
  cilPaperclip = 'cilPaperclip',
  cilLocationPin = 'cilLocationPin',
  cilCallToAction = 'cilCallToAction',
  cilImage = 'cilImage',
  cilSun = 'cilSun',
  cilMoon = 'cilMoon',
  cilBell = 'cilBell',
  cisPeople = 'cisPeople',
  cilCheck = 'cilCheck',
  cilCheckDouble = 'cilCheckDouble',
  cilNotes = 'cilNotes',
  cilSync = 'cilSync',
  cilUser = 'cilUser',
  cilPeople = 'cilPeople',
  cilSquare = 'cilSquare',
  cilSnow = 'cilSnow',
  cilTruck = 'cilTruck',
  cilChevronLeft = 'cilChevronLeft',
  cilChevronRight = 'cilChevronRight',
  cilSearch = 'cilSearch'
}
